const mobileSection = $('#mobile-section');
const mobileCards = mobileSection.find('.mobile-card-parent');
const lottiesParent = mobileSection.find('.mobile-lottie-parent');
const mobileBtn = mobileSection.find('.button-parent');
let lottieOverflows;
const mobileLotties = [];
const mobileLottiesDirections = [];
const durationCardIn = 0.767;
const durationCardOut = 0.667;
const delayCardsInOut = 0.1;
const delayCardOut = durationCardOut + delayCardsInOut;
const stepDuration = durationCardIn + delayCardOut;
let leftCardOffset = isDesktop() ? '17.8%' : '100%';
let rightCardOffset = isDesktop() ? '46.2%' : '100%';
let scrollTL, mobileTL;
const mobileSectionTriggers = [];

const updateOffsets = () => {
  leftCardOffset = isDesktop() ? '17.8%' : '100%';
  rightCardOffset = isDesktop() ? '46.2%' : '100%';
};

const cardIn = (currentCard) => {
  const cardType = currentCard.hasClass('left') ? 'left' : 'right';
  const cardInTL = gsap.timeline({ paused: true });
  const cardLine = currentCard.find('.descriptor-title-line');
  const cardContent = currentCard.find('.descriptor-title, .descriptor-bottom');
  cardInTL.add(
    gsap.fromTo(
      currentCard,
      {
        top: '100%',
      },
      {
        top: cardType == 'left' ? leftCardOffset : rightCardOffset,
        duration: durationCardIn,
      }
    )
  );
  cardInTL.add(
    gsap.fromTo(
      cardLine,
      {
        width: '0%',
      },
      {
        width: '100%',
        duration: durationCardIn,
      }
    ),
    0
  );
  cardInTL.add(
    gsap.fromTo(
      cardContent,
      {
        opacity: 0,
        y: '2vw',
      },
      {
        opacity: 1,
        y: 0,
        duration: durationCardIn,
      }
    ),
    0
  );

  return cardInTL;
};

const cardOut = (currentCard) => {
  const cardHeight = currentCard.outerHeight();
  const windowHeight = $(window).outerHeight();
  const percentOffset = cardHeight / (windowHeight / 100);
  const cardType = currentCard.hasClass('left') ? 'left' : 'right';
  const cardInTL = gsap.timeline({ paused: true });
  cardInTL.add(
    gsap.fromTo(
      currentCard,
      {
        top: cardType == 'left' ? leftCardOffset : rightCardOffset,
      },
      {
        top: `-${percentOffset}%`,
        duration: durationCardOut,
      }
    )
  );

  return cardInTL;
};

const overflowHide = (index) => {
  const currentOverflow = lottieOverflows.eq(index);
  const currentLottie = currentOverflow.find('.mobile-lottie-player');
  const overflowTL = gsap.timeline({ paused: true });
  overflowTL.add(
    gsap.fromTo(
      currentOverflow,
      {
        height: '100%',
      },
      {
        height: '0%',
        duration: stepDuration - 0.4,
        onStart: () => {
          mobileLotties[index + 1].pause();
          mobileLotties[index + 1].currentTime = 0;
        },
        onComplete: () => {
          mobileLotties[index + 1].play();
          mobileLotties[index].pause();
          mobileLotties[index].currentTime = 0;
        },
        onReverseComplete: () => {
          mobileLotties[index].play();
        },
      }
    )
  );
  overflowTL.add(
    gsap.fromTo(
      currentLottie,
      {
        y: 0,
      },
      {
        y: '-10%',
        duration: durationCardOut + durationCardIn,
      }
    ),
    0
  );
  return overflowTL;
};

const scrollAnimation = () => {
  const scrollTL = gsap.timeline({ paused: true });
  for (let i = mobileCards.length - 1; i >= 0; i--) {
    const currCard = mobileCards.eq(i);
    const nextCard = mobileCards.eq(i + 1);
    const prevCard = mobileCards.eq(i - 1);
    scrollTL.addLabel(`step${i}`, i * stepDuration);
    if (!currCard.is(mobileCards.last())) {
      scrollTL.add(overflowHide(i).play(), `step${i}`);
      scrollTL.add(cardOut(currCard).play(), `step${i}`);
      scrollTL.add(cardIn(nextCard).play(), `step${i}+=${delayCardOut}`);
    }
  }

  scrollTL.progress(0);

  return scrollTL;
};

const addMobileAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const mobileTL = gsap.timeline({ paused: true });
  mobileTL.add(
    animateSectionTopperIn({
      sectionParent: mobileSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  mobileTL.add(elementInAnimationYWOpacity(mobileCards.eq(0), '34.2%', 0, 1, 1, 1, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.3);
  mobileTL.add(elementInAnimationYWOpacity(lottiesParent, '17.1%', 0, 1, 1, 1, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
  //mobileTL.add(addElementInAnimation(mobileCards.eq(0), '34.2%', 1, 0).play(), 0.3);
  //mobileTL.add(addElementInAnimation(lottiesParent, '17.1%', 1, 0).play(), 0);
  mobileTL.add(() => {
    mobileLotties[0].play();
  }, 0.5);

  addBtnAnimation(mobileBtn, 50, true);
  //mobileTL.add(addBtnAnimation(mobileBtn, 50).play(), 0.5);

  return mobileTL;
};

const addMobileLottie = () => {
  const lottieSpeeds = [1, 1, 1, 1];
  const mobileContent = mobileSection.find('.mobile-section-content-scroller');
  lottieOverflows = mobileSection.find('.mobile-lottie-overflow');

  lottieOverflows.each(function (i) {
    const mobileLottie = $(this).find('.mobile-lottie-player').get(0);
    mobileLottie.load();
    mobileLottie.play().catch(() => mobileLottie.pause());
    $(this).css('z-index', `${1000 - i}`);
    mobileLottiesDirections.push(1);
    mobileLotties.push(mobileLottie);
  });

  let scrollTL = scrollAnimation();
  const mobileTL = isDesktop() ? addMobileAnimation() : false;

  $(window).on('deviceChange', function () {
    updateOffsets();
    if (scrollTL) scrollTL.kill();
    scrollTL = scrollAnimation();
  });

  const triggerOffset = isDesktop() ? 120 : 90;
  let firstIn = true;
  ScrollTrigger.create({
    trigger: mobileSection,
    start: `top top+=${triggerOffset}%`,
    end: `top+=3% top`,
    once: true,
    onUpdate: (self) => {
      mobileTL ? mobileTL.progress(self.progress) : false;
    },
  });

  ScrollTrigger.create({
    trigger: mobileContent,
    start: 'top top',
    end: 'bottom bottom',
    onUpdate: (self) => {
      const progress = self.progress;
      scrollTL.progress(progress);
    },
  });
};

/*
$(window).on('heroReady', function () {
addMobileLottie();
});
*/

addSectionObserver(mobileSection, addMobileLottie);